import { Pagination as AntPagination } from 'antd';

interface PaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  pageSize?: number;
}

export function Pagination({ page, totalPages, onPageChange, pageSize = 20 }: PaginationProps) {
  if (totalPages <= 1) return null;
  return (
    <div className="flex justify-end pt-2">
      <AntPagination
        current={page + 1}
        total={totalPages * pageSize}
        pageSize={pageSize}
        showSizeChanger={false}
        onChange={(p) => onPageChange(p - 1)}
      />
    </div>
  );
}
